export default {
  N_A: `N/A`,
  UNASSIGNED_SHIFT: `Non assigné`,
  VARIABLE_END_TIME: `Heure de fin variable`,
  OVERTIME: `Temps supplémentaire`,
  ON_CALL: `Sur appel`,
  IS_ABSENT: `Est absent`,
  IS_ARRIVING_AT: `Arrivé à {{ arrivalTime }}`,
  IS_LEAVING_AT: `Parti à {{ departureTime }}`,
  REPLACES_THIS_EMPLOYEE: `Remplace {{ name }}`,
  UNAVAILABLE_ISSUES: `À des problèmes non qui ne peuvent pas être affichés en raison de permissions manquantes`,
  IN_TIME_OFF: `En congé`,
  UNAPPROVED_TIME_OFF: `Congé non approuvé`,
  IS_IRREPLACEABLE: `Ne doit pas être remplacé`,
  NEEDS_REPLACEMENT: `Doit être comblé`,
  NO_EMPLOYEE_AVAILABLE: `Aucun employé disponible`,
  HAS_SPECIFIC_REQUIREMENTS: `A des requis spécifiques`,
  COVEREDOTHERUNIT: `Couvert par une autre unité`,
  TODAY: `Aujourd'hui`,
  NO_PROJECT: `Aucun projet`,
  NO_TEAM: `Aucune équipe`,
  ABSENCES: `Absences`,
  PROJECT_VIEW_NO_PROJECTS: `Choisissez un projet dans les filtres afin de l'afficher lorsque vous êtes en vue par projet.`,
  TEAM_VIEW_NO_TEAMS: `Choisissez une équipe dans les filtres afin  de l'afficher lorsque vous êtes en vue par équipe.`,
  NO_FILTER_LARGE_COMPANY: `Choisissez un filtre dans la barre de filtres afin de charger l'horaire.`,
  EVENT_SUMMARY: `<0>{{ name }}</0> - {{ positionName }} <1>({{ start }} - {{ end }})</1>`,
  SEE_PUNCHCARD: `Voir carte de temps`,
  NO_EVENTS_TO_SHOW: `Aucun quart de travail à afficher.`,
  WAGE_PREMIUM_HOUR: `\${{amount}} extra par heure`,
  WAGE_PREMIUM_SHIFT: `\${{amount}} extra par quart`,
  WAGE_PREMIUM_MULTIPLICATOR: `Multiplicateur {{amount}}x`,
  IMPORT: `Importer des quarts`,
  NOTHING_TO_SHOW: `Aucun quart ni congé`,
  SHIFT_IN_LIST_WARNING: `Ce quart de travail est dans une liste de contact, assigner un nouvel employé sur le quart le rendra indisponible dans la liste.`,
  SHIFT_IN_LIST_ERROR_MAKING_INELIGIBLE: `Il y a eu une erreur en rendant le quart de travail indisponible dans la liste, veuillez aller dans la liste pour vérifier qu'il n'est plus éligible.`,
  NO_PROCEDURE_WARNING: `Il n'y a aucune procédure de disponible pour l'horaire. Les employés ne seront pas classés ni filtrés.`,
  SUMMARY: {
    TITLE: `Sommaire`,
    PLANNED_HOURS: `{{ numberOfAssignedHours }} / {{ numberOfHours }} heures`,
    NUMBER_OF_SHIFTS: `{{ numberOfAssignedEvents }} / {{ numberOfEvents }} quarts`
  },
  WARNINGS: {
    CANT_DROP_PROJECT: `Il n'est pas permis d'assigner le quart au projet`,
    CANT_DROP_TIMEOFF: `Il n'est pas permis d'assigner le quart à un congé`,
    CANT_DROP_UNASSIGNABLE: `Vous ne pouvez assigner à cette position`,
    NO_SHIFT_TO_SYNC: `Aucun quart à synchroniser`,
    NO_SHIFT_TO_SYNC_DESC: `Il y a aucun quart de travail à synchroniser. Verifier votre filtre ou ajouter des quarts de travail.`
  },
  CONFIRM_CHANGE_MODAL: {
    TITLE: `Confirmez les changements`,
    SUMMARY: `Voulez-vous vraiment modifier les quarts de travail?`,
    ERROR_LOADING: `Quarts de travail non disponibles.`,
    CONFIRM_SHIFT_CHANGES_START: `Début changé du <0>{{ start }}</0> au <1>{{ oldStart }}</1>`,
    CONFIRM_SHIFT_CHANGES_END: `Fin changé du <0>{{ end }}</0> au <1>{{ oldEnd }}</1>`,
    CONFIRM_SHIFT_CHANGES_POSITION: `Position changée de <0>{{ oldPosition }}</0> à <1>{{ position }}</1>`,
    SEND_MODIFICATION: {
      LABEL: `Envoyer un avis de modification`,
      DESCRIPTION: `Cela enverra un avis de modification à tous les employés qui ont déjà reçu un avis de notification.`
    }
  },
  CONFIRM_PASTE_MODAL: {
    TITLE: `Confirmer l'ajout de quarts`,
    SUMMARY: `Voulez-vous vraiment coller ces quarts de travail?`,
    DESCRIPTION: `Vous allez coller {{ count }} quart à l'horaire`,
    DESCRIPTION_other: `Vous allez coller {{ count }} quarts à l'horaire`,
    DESCRIPTION_WITH_DATE: `Vous allez coller {{ count }} quart à l'horaire le {{pasteDate}}.`,
    DESCRIPTION_WITH_DATE_other: `Vous allez coller {{ count }} quarts à l'horaire le {{pasteDate}}.`,
    CLEAR_COPIED_EVENTS: `Annuler la copie`
  },
  AUTOFILL_PROCEDURE_MODAL: {
    TITLE: `Choisir une procédure pour le comblement automatique`,
    SUMMARY: ``,
    NO_PROCEDURE: `Aucune procédure`,
    NO_PROCEDURE_WARNING: `Il n'y a aucune procédure de disponible pour l'horaire. Les quarts de travail seront automatiquement comblés sans utiliser de filtre ou de classement.`
  },
  EDIT_MODAL: {
    TITLE: `Modification d'un quart de travail`,
    SUMMARY: ``,
    SHIFT: `Quart`,
    CONFIRMATION: `Statut de notification`,
    HISTORY: `Historique`,
    SHIFT_NOT_CONFIRMED: `Le quart de travail n'a pas notifié.`,
    TIMEOFF_NOT_CONFIRMED: `Le congé n'a pas encore été notifié.`,
    EVENT_DELETED: `Le quart de travail a été supprimé et ne peut être trouvé.`,
    EVENT_FINALIZED: `Le quart de travail a été finalisé et ne peut être modifié.`,
    SPECIFIC_RESTRICTIONS: `Restriction spécifique: {{  specificRestrictions }}`,
    SPECIFIC_RESTRICTIONS_other: `Restrictions spécifiques: {{  specificRestrictions }}`,
    HISTORY_DIFFS: {
      CREATED: `<1>{{ time }}</1> {{ date }} crée par <0>{{ name }}</0>`,
      EDITED: `<1>{{ time }}</1> {{ date }} modifié par <0>{{ name }}</0>`,
      VIEWED_BY_USER: `<1>{{ time }}</1> {{ date }} vu par <0>{{ name }}</0>`,
      START_CHANGED: `L'heure de début a été modifiée de <0>{{ before }}</0> à <1>{{ after }}</1>`,
      END_CHANGED: `L'heure de fin a été modifiée de <0>{{ before }}</0> à <1>{{ after }}</1>`,
      EMPLOYEEID_ASSIGNED: `<1>{{ after }}</1> a été assigné au quart de travail`,
      EMPLOYEEID_UNASSIGNED: `<0>{{ before }}</0> a été enlevé du quart de travail<1></1>`,
      EMPLOYEEID_CHANGED: `<1>{{ after }}</1> a été assigné à la place de <0>{{ before }}</0>`,
      POSITIONID_CHANGED: `Le quart de travail a été déplacé de la position <0>{{ before }}</0> à <1>{{ after }}</1>`,
      COMMENT_ADDED: `Le commentaire suivant a été ajouté: "<1>{{ after }}</1>"`,
      COMMENT_REMOVED: `Le commentaire suivant a été enlevé: "<0>{{ before }}</0>"`,
      COMMENT_CHANGED: `Le commentaire a été changé de <0>{{ before }}</0> à <1>{{ after }}</1>`,
      UNFINALIZED: `Le quart de travail n'était plus finalisé`,
      FINALIZED: `Le quart de travail a été finalisé`,
      UNRESOLVED: `Les problèmes d'horaires liées à ce quart de travail ont étés résolus`,
      RESOLVED: `Les problèmes d'horaires liées à ce quart de travail n'étaient plus résolus`,
      RESTORED: `Le quart de travail a été restauré`,
      CANCELLED: `Le quart de travail a été annulé`,
      PUBLISHED: `Le quart de travail a été publié`,
      UNPUBLISHED: `La publication a été annulée`,
      ADDED_TO_CONTACT_LIST: `A été ajouté dans une liste de remplacement`,
      ISEXTRASHIFT_CHANGED: `Option d'heure de fin variable modifiée`,
      ISOVERTIME_CHANGED: `Option de temps supplémentaire modifiée`,
      ISONCALL_CHANGED: `Option de quart sur appel modifiée`,
      ISIRREPLACEABLE_CHANGED: `Option non remplaçable modifiée`,
      NEEDSREPLACEMENT_CHANGED: `Option quart à combler modifiée`,
      NOEMPLOYEEAVAILABLE_CHANGED: `Option aucun employé disponible modifiée`,
      HASSPECIFICREQUIREMENTS_CHANGED: `Option a des requis spécifiques modifiée`,
      COVEREDOTHERUNIT_CHANGED: `Option couvert par une autre unité modifiée`,
      PROJECTS_CHANGED: `Projets modifiés`,
      DEPARTMENTS_CHANGED: `Départements modifiés`,
      BREAKS_CHANGED: `Pauses modifiées`,
      WAGEPREMIUMS_CHANGED: `Primes modifiées`,
      REQUIREDATTRIBUTES_CHANGED: `Attributs requis modifiés`,
      BILLINGDETAILS_CHANGED: `Détails de facturation modifiés`,
      TAGS_CHANGED: `Étiquettes modifiées`
    },
    CONFIRMATION_EVENTS: {
      CONFIRMATION: `Confirmation`,
      CANCELLATION: `Annulation`,
      MODIFICATION: `Modification`,
      ACCEPTED_PHONE: `<0>{{ name }}</0> a démarré un appel {{ date }} à <1>{{ time }}</1>.`,
      ACCEPTED_EMAIL: `<0>{{ name }}</0> a envoyé un courriel {{ date }} à <1>{{ time }}</1>.`,
      CONFIRMED_PHONE: `Confirmé par l'employé assigné au téléphone {{ date }} à <1>{{ time }}</1>.`,
      CONFIRMED_EMAIL: `Confirmé par l'employé assigné {{ date }} à <1>{{ time }}</1>.`,
      OPENED_EMAIL: `Courriel ouvert {{ date }} à <1>{{ time }}</1>.`,
      DELIVERED_EMAIL: `Courriel reçu {{ date }} à <1>{{ time }}</1>.`,
      FAILED_PHONE: `L'appel a échoué {{ date }} à <1>{{ time }}</1>.`,
      FAILED_EMAIL: `Le courriel a échoué {{ date }} à <1>{{ time }}</1>.`,
      NOPHONE_PHONE: `L'utilisateur n'avait pas de numéro de téléphone {{ date }} à <1>{{ time }}</1>.`
    },
    CONFIRM_FOR_EMPLOYEE: `Confirmer le quart pour l'employé`,
    REASON_FOR_CHANGE: `La raison du changement: <0>{{ reason }}</0>.`,
    REASON_FOR_CHANGE_DESCRIPTION: `La raison du changement: <0>{{ reason }}</0>. Informations supplémentaires: <1>{{ description }}</1>.`,
    REASON_FOR_CREATION: `La raison de création: <0>{{ description }}</0>`,
    USER_FLAGS: {
      ISHOLIDAY: `Le quart de travail commence ou se termine un jour férié: {{holidayNames}}.`,
      MISSING_PERMISSIONS: `Vous n'avez pas les permissions pour voir ce problème.`,
      USER_IS_ELIGIBLE: `L'utilisateur est éligible pour le quart de travail`,
      USER_IS_NOT_ELIGIBLE: `L'utilisateur n'est pas éligible pour le quart de travail`,
      SOLVE_PROBLEMS: "Résoudre tous les problèmes d'éligibilité.",
      COULD_NOT_GET_ISSUES: `Impossible d'obtenir les problèmes. Il doit manquer la sélection de la position.`,
      hasRestrictions_MISSING: `L'employé a les restrictions suivantes: <0>{{ attributeNames }}</0>.`,
      missingSkills_MISSING: `L'employé n'a pas les compétences suivantes: <0>{{ attributeNames }}</0>.`,
      missingSkills_INFERIOR: `L'employé n'a pas le bon niveau sur les compétences suivantes: <0>{{ attributeNames }}</0>.`,
      missingRequirements_MISSING: `L'employé n'a pas les requis suivants: <0>{{ attributeNames }}</0>.`,
      missingRequirements_INFERIOR: `L'employé n'a pas le bon niveau sur les requis suivants: <0>{{ attributeNames }}</0>.`,
      missingRegion: `Mauvaise région, cet employé n'est pas à <0>{{ missingRegions }}<0>`,
      leaveOverlapping: `L'employé est absent.`,
      vacationOverlapping: `L'employé est en <0>{{ type }}</0> (<1>{{ dateText }}</1>).`,
      eventOverlapping: `L'employé est déjà à l'horaire <0>{{ eventText }}</0> au poste de <1>{{ positionName }}</1>`,
      eventOverlapping_PROJECT: `L'employé est déjà à l'horaire <0>{{ eventText }}</0> au poste de <1>{{ positionName }}</1> sur le projet <2>{{ projectName }}</2>`,
      eventDistance: `La distance au prochain quart n'est pas suffisante`,
      lockedToProject: `L'employé est verrouillé sur le projet <0>{{ projectName }}</0>`,
      preferredOnProject: `L'employé est préféré sur le projet <0>{{ projectName }}</0>`,
      maxNumberOfHours: `L'employé est déjà à l'horaire <0>{{ numberOfHours }} heures</0> sur un maximum de <0>{{ maxHours }} heures</0>. <1>({{ hoursText }})</1>`,
      maxNumberOfHoursPerDay: `L'employé est déjà à l'horaire <0>{{ numberOfHours }} heures</0> sur un maximum de <0>{{ maxHours }} heures</0> par jour.`,
      maxConsecutiveDays: `L'employé travaillerait <0>{{ numberOfConsecutiveDays }}</0> jours de suite sur un maximum de <0>{{ maxConsecutiveDaysNumber }}</0>.`,
      missingPosition: `L'employé ne peut pas travailler à cette position.`,
      unavailableAllDay: `L'employé n'est pas disponible cette journée.`,
      unavailableOverlap: `L'employé n'est pas disponible.`,
      noCurrentAvailability: `L'employé n'a pas de disponibilité à jour.`,
      pendingAvailability: `L'employé a des disponibilités en attente d'approbation.`,
      wrongDepartment: `L'employé n'est pas dans ce départment.`,
      wrongTeam: `L'employé n'est pas dans cette équipe.`,
      wrongProject: `L'employé n'est pas dans ce projet.`,
      maxConsecutiveTime: `Ce quart ferait travailler trop d'heures de suite à l'employé.`,
      missingAdjacentShiftBefore: `Il manque un quart avant ce quart pour que l'employé soit disponible.`,
      missingAdjacentShiftAfter: `Il manque un quart après ce quart pour que l'employé soit disponible.`,
      missingAdjacentShifts: `Il manque un quart adjacent pour que l'employé soit disponible.`,
      lockedToCurrent: `L'employé est verrouillé au projet du quart.`,
      preferredOnCurrent: `L'employé est préféré sur le projet du quart.`,
      blockedFromProject: `L'employé est bloqué sur le projet du quart.`,
      employeeExpiredContract: `Le contrat de l'employé est expiré.`,
      employeeExpiredPermit: `Le permis de l'employé est expiré.`,
      expiredEmployeeType: `Le type de l'employé est expiré.`,
      noContract: `L'employé n'a pas de contrat.`,
      noPermit: `L'employé n'a pas de permis.`,
      noEmployeeType: `L'employé n'a pas de type.`,
      beforeStartDate: `L'employé n'a pas encore commencé à travailler.`,
      afterEndDate: `L'employé a fini de travailler à cette date.`,
      archivedUser: `L'employé est archivé.`,
      employeeTypeInvalid: `N'a pas les données d'embauche requises`,
      userMightBeOnHoliday: `L'employé pourrait être en congé dû à un jour férié.`
    },
    USER_FLAGS_SHORT: {
      MISSING_PERMISSIONS: `Vous n'avez pas les permissions pour voir ce problème.`,
      hasRestrictions: `A des restrictions`,
      missingSkills: `Manque des compétences`,
      missingRequirements: `Manque des requis`,
      missingRegion: `Mauvaise région`,
      leaveOverlapping: `Absent`,
      vacationOverlapping: `En congé`,
      vacationDuringWeek: `En congé durant la semaine`,
      eventOverlapping: `Déjà à l'horaire`,
      eventDistance: `Pas assez de distance entre les quarts`,
      distanceNextShift_DETAIL: `Prochain quart {{ distanceNextShift}}h après`,
      distancePreviousShift_DETAIL: `Quart précédent {{ distancePreviousShift }}h avant`,
      lockedToProject: `Verrouillé sur un autre projet`,
      preferredOnProject: `Préféré sur un autre projet`,
      totalProjectExperience_DETAIL: `{{ totalProjectExperience }}h d'expérience sur le projet`,
      totalRelatedProjectExperience_DETAIL: `{{ totalProjectExperience }}h d'expérience en lien avec le projet`,
      maxNumberOfHours: `Trop d'heures`,
      maxNumberOfHours_DETAIL: `<0>{{ numberOfHours }} / {{ maxHours }}h</0> <1>({{ hoursText }})</1>`,
      maxNumberOfHoursPerDay: `Trop d'heures en une journée`,
      maxConsecutiveDays: `Trop de jours de suite`,
      missingPosition: `Ne peut travailler à cette position`,
      unavailableAllDay: `Indisponible cette journée`,
      unavailableOverlap: `Indisponible pendant le quart`,
      noCurrentAvailability: `Aucune disponibilité à jour`,
      pendingAvailability: `Disponibilités en attente`,
      wrongDepartment: `Mauvais département`,
      wrongTeam: `Mauvaise équipe.`,
      wrongProject: `Mauvais projet.`,
      maxConsecutiveTime: `Trop d'heures de suite`,
      missingAdjacentShiftBefore: `Quart précédent manquant`,
      missingAdjacentShiftAfter: `Quart suivant manquant`,
      missingAdjacentShifts: `Quart adjacent manquant`,
      lockedToCurrent: `Verrouillé au projet du quart`,
      preferredOnCurrent: `Préféré sur le projet du quart`,
      blockedFromProject: `Bloqué sur le projet du quart`,
      employeeExpiredContract: `Contrat expiré`,
      employeeExpiredPermit: `Permis expiré`,
      expiredEmployeeType: `Type expiré`,
      noContract: `Pas de contrat`,
      noPermit: `Pas de permis`,
      noEmployeeType: `Pas de type`,
      beforeStartDate: `Pas encore commencé à travailler`,
      afterEndDate: `Fini de travailler à cette date`,
      archivedUser: `Archivé`,
      NO_AVAILABILITY: `N'a pas de disponibilités à jour`,
      employeeTypeInvalid: `N'a pas les données d'embauche requises`,
      userMightBeOnHoliday: `Pourrait être en congé dû à un jour férié.`,
      isNotInWorkableHours: "Hors période d'emploi"
    },
    LOAD_UNQUALIFIED_USERS: `Cliquez ici pour voir les utilisateurs non qualifiés`,
    ELIGIBLE: `Éligible`,
    NOT_ELIGIBLE: `Non éligible`,
    SHOW_ONLY_ELGIBLE_ATTRIBUTES_USERS_DESCRIPTION: `Cette section vous permet de filtrer les utilisateurs selon leur éligibilité au quart de travail.`,
    PROCEDUREID: {
      LABEL: `Procédure à utiliser`,
      DESCRIPTION: `Sert à filter et à classer les employés.`
    }
  },
  CREATE_MODAL: {
    TITLE: `Création d'un quart de travail`,
    SUMMARY: ``
  },
  HISTORY_MODAL: {
    TITLE: `Information sur le quart`,
    SUMMARY: ``
  },
  SELECTION_OPTIONS: {
    COPIED_COUNT: `{{ count }} copié`,
    COPIED_COUNT_other: `{{ count }} copiés`,
    PASTE_COPIED_EVENTS: `Coller`,
    CLEAR_COPIED_EVENTS: `Annuler la copie`,
    COPY_SELECTION: `Copier la sélection`,
    EVENTS_PASTED_SUCCESSFULLY: `Les quarts ont étés collés`,
    AUTO_FILL_SELECTION: `Combler automatiquement`
  },
  VIEW_OPTIONS: {
    VIEW: `Vue`,
    DAILY: `Par jour`,
    WEEKLY: `Par semaine`,
    VIEW_OPTIONS: `Type de vue`,
    ORGANISATION_OPTIONS: `Options d'organisation`,
    RENDERING_OPTIONS: `Options d'affichage`,
    HIERARCHY_PROJECTS: `Par projet`,
    HIERARCHY_POSITIONS: `Par position`,
    HIERARCHY_USERS: `Par employé`,
    HIERARCHY_TEAMS: `Par équipe`,
    HIDECONFIRMEDSHIFTINSCHEDULER: `Statut de notification`,
    HIDEPUBLISHEDSTATUSINSCHEDULER: `Statut de publication`,
    SHOWTEMPLATESHIFTINDICATIONINSCHEDULE: `Statut de modèle d'horaire`,
    SHOWCANCELLEDSHIFT: `Quarts annulés`,
    SHOWTIMEOFFINSCHEDULE: `Rangée des congés`,
    SHOWABSENCESINSCHEDULE: `Rangée des absences`,
    HIDESCHEDULESUMMARYROW: `Rangée sommaire`,
    HIDESCHEDULESUMMARYCOLUMN: `Colonne sommaire`,
    HIDEEMPTYSCHEDULERROWS: `Rangées vides`,
    HIDECUSTOMCOLORS: `Couleurs personnalisées`,
    OPTIONS: `Options`
  },
  TOOLS: {
    IMPORT: `Importer`,
    TOOLS: `Outils`,
    APPLY_TEMPLATE: `Appliquer un modèle d'horaire`,
    EXPORT: `Exporter`,
    DAILY_REPORT_PDF: `Horaire journalier (PDF)`,
    WEEKLY_REPORT_EMPLOYEE_PDF: `Par employée (PDF)`,
    WEEKLY_REPORT_POSITION_PDF: `Par position (PDF)`,
    DAILY_REPORT_CSV: `Horaire journalier (CSV)`,
    SCHEDULE_RAW_CSV: `Horaire brut (CSV)`,
    SYNC_SCHEDULE: `Synchroniser l'horaire`,
    SYNC_PUNCHES: `Synchroniser les poinçons à l'horaire`,
    SHIFT_PUBLICATION: `Publier l'horaire complet`,
    QUICK_ASSIGN: `Assignation rapide`
  },
  CHANGE_REASONS: {
    NO_REASON: `Aucune raison (ignorer)`,
    CHANGED_HOURS: `Les heures du quart ont changé`,
    CHANGED_ASSIGNED_EMPLOYEE: `L'employé assigné a changé`,
    CANCELLATION: `Le quart de travail a été annulé`,
    OTHERS: `Autre (voir description)`,
    HASRESTRICTIONS: `L'employé avait des restrictions`,
    MISSINGSKILLS: `L'employé n'avait pas les bonnes compétences`,
    MISSINGREQUIREMENTS: `L'employé n'avait pas les bons requis`,
    MISSINGREGION: `L'employé n'était pas dans la bonne région`,
    VACATIONOVERLAPPING: `L'employé était en vacances`,
    EVENTOVERLAPPING: `L'employé était déjà à l'horaire`,
    EVENTDISTANCE: `L'employé avait un autre quart trop proche`,
    LOCKEDTOPROJECT: `L'employé était barré à un projet`,
    PREFERREDONPROJECT: `L'employé était préféré sur un projet`,
    MAXNUMBEROFHOURS: `L'employé avait trop d'heures`,
    MAXNUMBEROFHOURSPERDAY: `L'employé avait trop d'heures en une journée`,
    MAXCONSECUTIVEDAYS: `L'employé travaillait trop de jours de suite`,
    MISSINGPOSITION: `L'employé ne pouvait pas travailler à cette position`,
    LEAVEOVERLAPPING: `L'employé était absent`,
    UNAVAILABLEALLDAY: `L'employé n'était pas disponible de la journée`,
    UNAVAILABLEOVERLAP: `L'employé n'était pas disponible pendant le quart`,
    PENDINGAVAILABILITY: `L'employé avait des disponibilités en attente`,
    WRONGDEPARTMENT: `L'employé n'était pas dans ce département`,
    WRONGTEAM: `L'employé n'était pas dans cette équipe`,
    WRONGPROJECT: `L'employé n'était pas dans ce projet`,
    MAXCONSECUTIVETIME: `L'employé travaillait trop d'heures de suite`,
    MISSINGADJACENTSHIFTBEFORE: `L'employé n'avait pas un quart avant`,
    MISSINGADJACENTSHIFTAFTER: `L'employé n'avait pas un quart après`,
    MISSINGADJACENTSHIFTS: `L'employé n'avait pas de quart adjacent`,
    LOCKEDTOCURRENT: `L'employé était barré à ce projet`,
    PREFERREDONCURRENT: `L'employé était préféré sur ce projet`,
    BLOCKEDFROMPROJECT: `L'employé était bloqué sur ce projet`,
    EMPLOYEEEXPIREDCONTRACT: `Le contrat de l'employé était expiré`,
    EMPLOYEEEXPIREDPERMIT: `Le permis de l'employé était expiré`,
    EXPIREDEMPLOYEETYPE: `Le type de l'employé était expiré`,
    NOCONTRACT: `L'employé n'avait pas de contrat`,
    NOPERMIT: `L'employé n'avait pas de permis`,
    NOEMPLOYEETYPE: `L'employé n'avait pas de type`,
    BEFORESTARTDATE: `L'employé était à l'horaire avant sa date de début`,
    AFTERENDDATE: `L'employé était à l'horaire après sa date de fin`,
    ARCHIVEDUSER: `L'employé était archivé`,
    RESTORATION: 'Le quart de travail a été rétabli',
    IMPORT: {
      CERIDIAN_PUNCH_SYNC: `Synchronisé avec les cartes de temps de ceridian`
    }
  },
  eventForm: {
    ERROR_LOADING_FLAGS: `La disponibilité des employés n'a pas pu être chargée.`,
    OTHER_INFO: `Autres informations`,
    SHIFT_OPTIONS: `Options du quart de travail`,
    ELIGIBLE_POSITION: `Cette position n'est pas requise pour le projet assigné.`,
    REPLACE: `Remplacer`,
    REMOVE: `Supprimer`,
    ADD: `Ajouter`,
    SELECTEDSCHEDULETYPE: {
      LABEL: `Type de quart`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'assigner une heure de début et fin pré-déterminée au quart de travail.`
    },
    CUSTOM_SCHEDULE_TYPE: `Sur mesure`,
    TIME_CHANGED_RECALCULATE_BREAKS: `Cliquez ici pour recalculer les pauses, l'heure de début ou fin a été changé.`,
    MULTIPLE_VALUES: `Plusieurs valeurs`,
    CLICK_TO_EDIT: `Cliquez ici pour modifier`,
    EMPLOYEEID: {
      LABEL: `Utilisateur`,
      PLACEHOLDER: `Non-assigné`,
      DESCRIPTION: `Sert à assigner un utilisateur à un quart de travail, laissez-le vide afin de créer un quart de travail non assigné.`
    },
    POSITIONID: {
      LABEL: `Position`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Sert à assigner le quart de travail à une position.`
    },
    START: {
      LABEL: `Heure de début`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    END: {
      LABEL: `Heure de fin`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Si l'heure de fin est avant l'heure de début, le quart se déroulera sur 2 jours.`
    },
    STARTDATE: {
      LABEL: `Date de début`,
      PLACEHOLDER: ``,
      DESCRIPTION: `La date de fin sera automatiquement calculée par rapport à cette date.`
    },
    COMMENT: {
      LABEL: `Commentaire`,
      PLACEHOLDER: `Ajoutez des notes ou instructions pour l'employé.`,
      DESCRIPTION: `Sert à ajouter de l'information supplémentaire à un quart de travail, il sera visible par tous les utilisateurs qui peuvent voir le quart. Ce champ supporte les traductions en utilisant #fr et #en.`
    },
    ISEXTRASHIFT: {
      LABEL: `Heure de fin variable`,
      DESCRIPTION: `Le quart de travail n'a pas d'heure de fin définie.`
    },
    ISOVERTIME: {
      LABEL: `Quart de travail en temps supplémentaire`,
      DESCRIPTION: `Le quart de travail est considéré comme du temps supplémentaire et peut affecter la paie.`
    },
    ISONCALL: {
      LABEL: `Quart de travail sur appel`,
      DESCRIPTION: `Le quart de travail est considéré comme un quart de travail sur appel. Il ne sera pas pris en compte dans les heures totales assignées à l'employé.`
    },
    ISIRREPLACEABLE: {
      LABEL: `Ne doit pas être remplacé`,
      DESCRIPTION: `Seulement cet employé peut être assigné à ce quart de travail.`
    },
    NEEDSREPLACEMENT: {
      LABEL: `Doit être comblé`,
      DESCRIPTION: `Sert à indiquer que ce quart doit être comblé ou remplacé.`
    },
    NOEMPLOYEEAVAILABLE: {
      LABEL: `Aucun employé disponible`,
      DESCRIPTION: `Aucun employé n'est éligible pour effectuer ce quart de travail, il sera donc automatiquement non assigné.`
    },
    HASSPECIFICREQUIREMENTS: {
      LABEL: `A des requis spécifiques`,
      DESCRIPTION: `Le quart de travail ne peut être effectué que par un employé ayant les qualifications requises, elles peuvent se trouver dans le champ "Commentaire".`
    },
    COVEREDOTHERUNIT: {
      LABEL: `Couvert par une autre unité`,
      DESCRIPTION: `Sert à indiquer qu'un quart de travail sera couvert par une autre unité d'affaires.`
    },
    PROJECTS: {
      LABEL: `Projet`,
      PLACEHOLDER: `Ajoutez ce quart à un projet`,
      DESCRIPTION: ``
    },
    TEAM: {
      LABEL: `Équipe`,
      PLACEHOLDER: `Ajoutez ce quart à une équipe`,
      DESCRIPTION: ``
    },
    TAGS: {
      LABEL: `Étiquettes`,
      PLACEHOLDER: `Ajoutez des étiquettes au quart de travail`,
      DESCRIPTION: `Sert à ajouter des étiquettes à un quart de travail, telles que des emplacements, des clients et des primes.`
    },
    CHANGEREASON: {
      LABEL: `Raison expliquant le changement (optionnel)`,
      DESCRIPTION: `Sert à expliquer la raison du changement au quart de travail dans l'historique des modifications.`
    },
    CHANGEDESCRIPTION: {
      LABEL: `Description du changement`,
      PLACEHOLDER: `Ajoutez une description si aucune option ne parvient à expliquer le changement.`,
      DESCRIPTION: `Sert à ajouter plus de détails liées au changement dans l'historique des modifications.`
    },
    CREATIONDESCRIPTION: {
      LABEL: `Raison de la création`,
      PLACEHOLDER: `Ajoutez une description si vous devez justifier la création de ce quart.`,
      DESCRIPTION: `Sert à ajouter plus de détails à l'historique des modifications.`
    },
    UPDATEFUTURERECURRENCE: {
      LABEL: `Modifier tous les quarts dans le futur de cette récurrence`,
      DESCRIPTION: `Si décoché, seulement le quart actuel sera modifié.`
    },
    BREAKS: {
      TITLE: `Pauses`,
      LABEL: `Pauses`,
      SUMMARY: `Ajoutez des pauses payées et non payées au quart de travail.`,
      DESCRIPTION: `Ajoutez des pauses payées et non payées au quart de travail.`,
      RECALCULATE_BREAKS: `Recalculer les pauses`,
      CUSTOM: `Pause sur mesure`,
      CUSTOM_NAME: `Pause {{ index }}`,
      ADD_BREAK: 'Ajouter une pause'
    },
    BREAKNAME: {
      LABEL: `Nom de la pause`,
      PLACEHOLDER: `Ajoutez un nom à la pause`,
      DESCRIPTION: `Sert à repérer facilement la pause.`
    },
    BREAKDURATION: {
      LABEL: `Durée de la pause`,
      PLACEHOLDER: `Ajoutez la longueur de la pause`,
      DESCRIPTION: `La durée de la pause est en minutes`
    },
    BREAKPAID: {
      LABEL: `Pause payée`,
      DESCRIPTION: ``
    },
    MULTI_CREATION: `Création multiple`,
    DUPLICATENUMBER: {
      LABEL: `Nombre de quarts identiques`,
      PLACEHOLDER: `Entrez un nombre`,
      DESCRIPTION: `Exemple : "5" créera 5 quarts de travail similaires dans l'horaire.`
    },
    ADDTOOTHERDAYS: {
      LABEL: `Ajouter à plusieurs jours`,
      DESCRIPTION: `Sert à ajouter un quart similaire sur plusieurs jours, peut être combiné avec le nombre de quarts identiques afin de créer un ensemble de quarts similaires sur plusieurs jours dans l'horaire.`
    },
    WAGEPREMIUMS: {
      TITLE: `Primes salariales`,
      LABEL: `Primes salariales`,
      SUMMARY: `Ajoutez des modificateurs de salaire au quart de travail.`,
      DESCRIPTION: `Ajoutez des modificateurs de salaire au quart de travail.`,
      ADD_WAGE_PREMIUM: `Ajouter une prime`,
      SHIFT_DURATION: `Durée du quart`
    },
    WAGEPREMIUMFULLSHIFT: {
      LABEL: `Appliquer au quart en entier`,
      DESCRIPTION: ``
    },
    WAGEPREMIUMOVERRIDEOVERTIME: {
      LABEL: `Désactiver le calcul automatique du temps supplémentaire pour la semaine de l'employé`,
      DESCRIPTION: `Les primes de temps supplémentaire devront être ajoutés manuellement pour cette carte ainsi que toutes les autres cartes dans la même semaine de paie.`
    },
    WAGEPREMIUMHOURS: {
      LABEL: `Quantité`,
      PLACEHOLDER: `Entrez un chiffre`,
      DESCRIPTION: `Nombre d'heures auxquels appliquer la prime. Utilisation la notation décimale, par exemple pour une heure et quinze minutes, entrez "1.25".`
    },
    WAGEPREMIUMUNITS: {
      LABEL: `Quantité`,
      PLACEHOLDER: `Entrez un chiffre`,
      DESCRIPTION: `Nombre d'unités auxquels appliquer la prime.`,
      UNITS: `unités`
    },
    WAGEPREMIUMS_NOT_CONFIGURED: {
      DESCRIPTION: `Aucun code de primes configuré `,
      LINK: `Gérer les codes de primes ici`
    },
    WAGE_PREMIUM_FULL_SHIFT_CALCULATED_ON_SUBMIT: 'La valeur de cette prime est calculée en sauvegardant la carte de temps.',
    REQUIREDATTRIBUTES: {
      TITLE: `Attributs requis`,
      LABEL: `Attributs requis`,
      DESCRIPTION: `Ajoutez des attributs supplémentaires requis pour ce quart de travail`
    },
    SENDMODIFICATIONCANCELLATIONEMAILS: {
      LABEL: `Envoyer un avis de modification/annulation`,
      DESCRIPTION: `Un avis de modification sera envoyé à l'employé assigné si des informations importantes ont été modifiées (début, fin, date, position, projets ou commentaire). Un avis d'annulation sera envoyé à l'employé qui est déassigné du quart de travail.`
    },
    SENDNOTIFICATIONFORNEWEMPLOYEE: {
      LABEL: `Envoyer un avis au nouvel employé assigné`,
      DESCRIPTION: `Un avis sera envoyé au nouvel employé assigné.`
    }
  },
  reports: {
    CSV_FORMATTED_REPORT_TITLE: `csv_rapport_journalier_{{ date }}`,
    CSV_REPORT_RAW_TITLE: `csv_rapport_brut_{{ start }}-{{ end }}`,
    PDF_DAILY_REPORT_TITLE: `pdf_rapport_journalier_{{ date }}`,
    PDF_WEEKLY_REPORT_TITLE: `pdf_rapport_hebdomadaire_{{ start }}-{{ end }}`,
    DAILY_REPORT_LEGEND: `(R;L : Retard / A : Absent / V : Congé)`,
    GENERATED_BY: `Généré par`,
    PRIORITY: `Priorite`,
    SENIORITY: `Anciennete`,
    EMPLOYEE_NUMBER: `Numero d'employe`,
    FIRSTNAME: `Prenom`,
    LASTNAME: `Nom`,
    PRIMARY_OCCUPATION: `Occupation primaire`,
    POSITION: `Position`,
    START: `Heure de debut`,
    END: `Heure de fin`,
    STATUS: `Statut d'emploi`,
    HOURS_WORKED: `Heures travaillees`,
    HOURS_PLANNED: `Heures planifiees`,
    LOCATION_TAGS: `Emplacements`,
    REGION: `Regions`,
    CLIENT_TAGS: `Clients`,
    RESOURCE_TAGS: `Ressources`,
    IRREPLACEABLE: `Ne doit pas être remplace`,
    NEEDSREPLACEMENT: `Quart à combler`,
    COVEREDOTHERUNIT: `Couvert par une autre unité`,
    VARIABLE_END_TIME: `Heure de fin variable`,
    OVERTIME: `Temps supplementaire`,
    ISONCALL: `Sur appel`,
    NO_EMPLOYEE_AVAILABLE: `Aucun employe disponible`,
    HAS_SPECIFIC_REQUIREMENTS: `A des requis spécifiques`,
    COMMENT: `Commentaire`,
    PROJECT: `Nom du projet`,
    PROJECT_CODE: `Code du projet`,
    PROJECT_OWNERS: `Responsables du projet`,
    LOCKED_TO: `Verrouille sur (projets)`,
    PREFERRED_ON: `Prefere sur (projets)`,
    BLOCKED_FROM: `Bloque sur (projets)`,
    EMPLOYEE: `Employé`,
    SHIFTS: `Quarts de travail`,
    HOURS_MSG: `Heures`,
    TAGS: `Étiquettes`,
    UNASSIGNED: `Quart de travail non-assigné`,
    SCHEDULE_HEADER_WEEKLY: `Horaire du {{ start }} au {{ end }}`,
    ALL_DAY: `Toute la journée`,
    TIME_OFF: `Congé`
  },
  CONTEXT_MENU: {
    NO_OPTIONS: `Aucune option`,
    CONFIRMED_IN_PERSON: `Accuser réception manuellement`,
    FINALIZE: `Finaliser`,
    UNFINALIZE: `Annuler la finalisation`,
    PUBLISH: `Publier`,
    UNPUBLISH: `Annuler la publication`,
    UNASSIGN_EMPLOYEE: `Déassigner l'employé`,
    UNASSIGN_EMPLOYEES: `Déassigner les employés`,
    DELETE: `Supprimer`,
    CANCEL: `Annuler le quart`,
    COPY: `Copier`,
    PASTE: `Coller`,
    COPY_SELECTION: `Copier la sélection`,
    RESTORE_SHIFT: `Rétablir`,
    CREATE_LEAVE: `Créer une requête d'absence`,
    OPEN_THE_USER_SCHEDULE: `Voir dans l'horaire de l'utilisateur`,
    OPEN_THE_SHIFT_CONTACT_LIST: `Liste de contact correspondante`,
    OPEN_THE_SHIFT_TEMPLATE: `Modèle d'horaire correspondant`,
    OPEN_THE_SHIFT_CONTACT_LIST_MOBILE: `Ouvrir la liste de contact correspondante`,
    OPEN_THE_SHIFT_TEMPLATE_MOBILE: `Ouvrir le modèle d'horaire correspondant`,
    CREATE_LIST: `Créer une liste à partir du quart`,
    SEND_CONFIRMATIONS: `Envoyer des notifications`,
    SEND_TIMEOFF_NOTIFICATION: `Envoyer une notification de congé`,
    SEND_SHIFT_NOTIFICATION: `Envoyer une notification de quart de travail`,
    EDIT_SELECTED: `Modifier la sélection`,
    EDIT_SHIFT: `Modifier`,
    DELETE_SELECTED: `Supprimer la sélection`,
    FINALIZE_SELECTED: `Finaliser la sélection`,
    UNFINALIZE_SELECTED: `Annuler la finalisation de la sélection`,
    PUBLISH_SELECTED: `Publier la sélection`,
    UNPUBLISH_SELECTED: `Annuler la publication de la sélection`,
    CANCEL_SELECTED: `Annuler la sélection`,
    RESTORE_SELECTED: `Rétablir la sélection`,
    CREATE_LIST_SELECTED: `Créer une liste à partir de la sélection`,
    CREATE_PUNCHCARD: `Créer une carte de temps`,
    SELECT_SHIFTS: `Sélectionner les quarts`,
    SELECTED: `{{ count }} quart de travail sélectionné`,
    SELECTED_other: `{{ count }} quarts de travail sélectionnés`,
    SELECTED_TIMEOFF: `{{ count }} congé sélectionné`,
    SELECTED_TIMEOFF_other: `{{ count }} congés sélectionnés`,
    OPEN_PUNCH_CARD: `Carte de temps`,
    OPEN_TIME_OFF: `Requête de congé`,
    OPEN_COMMENTS: `Commentaires`,
    OPEN_ATTENDANCE: `Requête d'absence`,
    OPEN_PUNCH_CARD_MOBILE: `Ouvrir la carte de temps`,
    OPEN_TIME_OFF_MOBILE: `Ouvrir la requête de congé`,
    OPEN_ATTENDANCE_MOBILE: `Ouvrir la requête d'absence`,
    OPEN_USER: `Profil employé`,
    OPEN_USER_SCHEDULE: `Horaire employé`,
    OPEN: `Ouvrir`,
    ADVANCED: `Avancé`
  },
  SEND_CANCELLATION_NOTICE: `Un avis d'annulation sera envoyé à tous les employés affectés.`,
  FINALIZE: {
    TITLE: `Finaliser les quarts de travail`,
    SUMMARY: `Voulez-vous vraiment marquer les quarts de travail suivants comme étant finalisés?`,
    DESCRIPTION: `Ceci empêchera la modification des quarts de travail tant que la finalisation ne sera pas annulée`,
    ERROR_LOADING: `Un ou plusieurs des quarts de travail que vous tentiez de finaliser ont étés supprimés.`
  },
  UNFINALIZE: {
    TITLE: `Annuler la finalisation des quarts de travail`,
    SUMMARY: `Voulez-vous vraiment marquer les quarts de travail suivants comme n'était plus finalisés?`,
    DESCRIPTION: `Ceci permettra de nouveau aux autres utilisateurs de modifier les quarts de travail.`,
    ERROR_LOADING: `Un ou plusieurs des quarts de travail dont vous tentiez d'annuler la finalisation ont étés supprimés.`
  },
  DELETE_MODAL: {
    TITLE: `Supprimer les quarts de travail`,
    SUMMARY: `Voulez-vous vraiment supprimer les quarts de travail suivants?`,
    DESCRIPTION: `Cette action est irréversible et ne sera pas sauvegardée dans l'historique des quarts de travail.`,
    PUNCHCARDS_ASSOCIATED: `Un ou plusieurs des quarts de travail que vous tentez de supprimer ont une carte de temps associée.`,
    SENDCANCELLATIONEMAILS: {
      LABEL: `Envoyer un avis d'annulation`,
      DESCRIPTION: `Cela enverra un avis d'annulation à tous les employés affectés.`
    },
    DELETEFUTURERECURRENCE: {
      LABEL: `Supprimer la récurrence`,
      DESCRIPTION: `Cela supprimera tous les quarts futurs de cette récurrence.`
    },
    DELETEEVENTSWITHPUNCHCARDS: `Supprimer les quarts de travail avec des cartes de temps associées`
  },
  UNASSIGN_EMPLOYEE_MODAL: {
    TITLE: `Déassigner les employés`,
    SUMMARY: `Voulez-vous vraiment déassigner les employés des quarts de travail suivants?`,
    ERROR_LOADING: `Un ou plusieurs des quarts de travail dont vous tentiez de déassigner l'employé ont été supprimés.`
  },
  CANCEL_MODAL: {
    TITLE: `Annuler les quarts de travail`,
    SUMMARY: `Voulez-vous vraiment annuler les quarts de travail suivants?`,
    DESCRIPTION: `Une fois annulés, les quarts de travail n'apparaissent plus dans les rapports. Cette action est similaire à les supprimer, mais de manière réversible et sauvegardée dans l'historique des modifications.`,
    UNASSIGN_EMPLOYEE: `Déassigner l'employé`,
    CANCEL_SHIFT: `Annuler le quart de travail`,
    ERROR_LOADING: `Un ou plusieurs des quarts de travail que vous tentiez d'annuler ont étés supprimés.`,
    CANCELEMPLOYEE: {
      LABEL: `Sélectionnez l'action`,
      DESCRIPTION: `Déassigner l'employé laissera le quart de travail à l'horaire, mais annuler le quart l'enlèvera de l'horaire et des rapports.`
    },
    CANCELFUTURERECURRENCE: {
      LABEL: `Annuler la récurrence`,
      DESCRIPTION: `Cela annulera tous les quarts futurs de cette récurrence.`
    },
    SENDCANCELLATIONEMAILS: {
      LABEL: `Envoyer un avis d'annulation`,
      DESCRIPTION: `Cela enverra un avis d'annulation uniquement aux employés assignés à un quart publié.`
    },
    CANCELLATIONCOMMENT: {
      LABEL: `Commentaire`,
      PLACEHOLDER: `Écrivez un commentaire`,
      DESCRIPTION: `Sert à donner plus d'informations aux employés qui étaient préalablement affectés aux quarts de travail, il sera envoyé dans l'avis d'annulation.`
    },
    REASON: {
      LABEL: `Raison de l'annulation`,
      PLACEHOLDER: `Écrivez la raison pour laquelle les quarts ont étés annulés`,
      DESCRIPTION: `Sert à expliquer la raison de l'annulation dans l'historique du quart de travail.`
    }
  },
  RESTORE_MODAL: {
    TITLE: `Rétablir les quarts de travail`,
    SUMMARY: `Voulez-vous vraiment rétablir les quarts de travail suivants?`,
    DESCRIPTION: `Une fois rétablis, les quarts de travail se retrouveront de nouveau à l'horaire.`,
    SENDCONFIRMATIONEMAILS: {
      LABEL: `Envoyer un avis de notification`,
      DESCRIPTION: `Cela enverra un avis de notification à tous les employés affectés.`
    },
    RESTORATIONCOMMENT: {
      LABEL: `Commentaire`,
      PLACEHOLDER: `Écrivez un commentaire`,
      DESCRIPTION: `Sert à donner plus d'informations aux employés qui vont recevoir un avis de notification.`
    },
    REASON: {
      LABEL: `Raison`,
      PLACEHOLDER: `Écrivez la raison pour laquelle les quarts ont étés rétablis`,
      DESCRIPTION: `Sert à inscrire l'explication dans l'historique du quart de travail.`
    }
  },
  PUBLISH_MODAL: {
    TITLE: `Confirmer les quarts de travail et congés`,
    SUMMARY: `Voulez-vous vraiment publier les quarts de travail et congés?`,
    DESCRIPTION: `Ceci enverra un avis de notification à tous les employés affectés.`,
    ERROR_LOADING: `Quarts de travail ou congés non disponibles`,
    EVENTS_TO_CONFIRM: `Quarts de travail`,
    TIMEOFF_TO_CONFIRM: `Congés`,
    EVENTS: `Quarts de travail`,
    TIMEOFFS: `Congés`,
    ALERT_CONFIRM_SHIFTS: `Une notification sera envoyée à tous les employés assignés aux quarts sélectionnés.`,
    ALERT_CONFIRM_TIMEOFFS: `Une notification de congé sera envoyée à tous les employés concernés.`,
    CONFIRM: {
      LABEL: `Envoyer une notification`,
      DESCRIPTION: `Sert à envoyer une notification par email et notification push aux employés assignés aux quarts de travail.`
    },
    RECONFIRM: {
      LABEL: `Re-notifier`,
      DESCRIPTION: `Sert à renvoyer une notification à des employés qui ont déjà reçu une notification.`
    },
    PHONECONFIRM: {
      LABEL: `Envoyer une notification`,
      DESCRIPTION: `Sert à envoyer une notification par téléphone et notification push à tous les employés assignés aux quarts de travail.`
    },
    RECONFIRMUNCONFIRMED: {
      LABEL: `Re-notifier les quarts ou congés non-confirmés`,
      DESCRIPTION: `Sert à renvoyer une notification à tous les employés n'ayant pas confirmé la réception.`
    },
    CUSTOMMESSAGE: {
      LABEL: `Message`,
      PLACEHOLDER: `Écrivez un message à envoyer`,
      DESCRIPTION: `Sert à envoyer un message qui sera énoncé durant un appel de notification, n'utilisez qu'une seule langue dans ce message.`
    },
    CONFIRMTIMEOFF: {
      LABEL: `Envoyer une notification de congé`,
      DESCRIPTION: `Sert à envoyer une notification de congé par email et notification push aux employés assignés aux congés.`
    },
    RANGE_TO_PUBLISH: {
      LABEL: `Période à publier`,
      DESCRIPTION: `Sert à publier une période différente ou plus grande qu'initialement sélectionnée.`
    }
  },
  PUBLISH: {
    TITLE: `Publier`,
    SUMMARY: `Voulez-vous vraiment publier les quarts de travail/congés suivants?`,
    ALERT: `Les employés assignés aux quarts verront ces quarts apparaître à leur horaire.`,
    ERROR_LOADING: `Un ou plusieurs des quarts de travail que vous tentiez de publier ont étés supprimés.`
  },
  UNPUBLISH: {
    TITLE: `Annuler la publication des quarts de travail`,
    SUMMARY: `Voulez-vous vraiment marquer les quarts de travail suivants comme n'étant plus publiés?`,
    ALERT: `Les employés assignés aux quarts ne les verront plus.`,
    ERROR_LOADING: `Un ou plusieurs des quarts de travail dont vous tentiez d'annuler la publication ont étés supprimés.`
  },
  CONFIRM: {
    TITLE: `Envoyer une notification de congé`,
    SUMMARY: `Voulez-vous vraiment envoyer une notification de congé à tous les employés concernés?`,
    ERROR_LOADING: `Un ou plusieurs des congés que vous avex sélectionné ont été supprimés.`
  },
  CONFIRM_SHIFT: {
    TITLE: `Envoyer une notification de quart de travail`,
    SUMMARY: `Voulez-vous vraiment envoyer une notification de quart de travail à tous les employés concernés?`,
    ERROR_LOADING: `Un ou plusieurs des quarts de travail que vous avez sélectionné ont été supprimés.`
  },
  FIX_USER_ELIGIBILITY_PROBLEMS_MODAL: {
    TITLE: `Régler les problèmes d'éligibilité de {{name}}`,
    SUMMARY: 'Que souhaitez vous mettre à jour?',
    POSITION: `Position`,
    ATTRIBUTES: `Attributs`,
    REGIONS: `Régions`,
    DEPARTMENT: `Départements`,
    PROJECT: `Projet`,
    STATUS: `Statut`,
    TEAM: `Équipe`,
    MAKE_ACTIVE: `Changer le statut de l'employé pour "actif"`
  },
  MULTI_EDIT_MODAL: {
    TITLE: `Modification de plusieurs quarts de travail`,
    SUMMARY: ``,
    SENDMODIFICATIONCANCELLATIONEMAILS: {
      LABEL: `Envoyer un avis de modification/annulation`,
      DESCRIPTION: `Un avis de modification sera envoyé aux employés assignés si des informations importantes ont été modifiées (début, fin, date, position, projets ou commentaire). Un avis d'annulation sera envoyé aux employés qui sont déassignés du quart de travail.`
    }
  },
  SCHEDULE_TEMPLATE_APPLY_MODAL: {
    TITLE: `Application d'un modèle d'horaire`,
    SUMMARY: ``,
    DESCRIPTION: `Cliquer sur "Soumettre" appliquera le modèle d'horaire sur tous les jours visibles, les quarts de travail appartenant déjà à ce modèle ne seront pas modifiés.`,
    SCHEDULETEMPLATEID: {
      LABEL: `Modèle d'horaire à appliquer`,
      DESCRIPTION: `Sélectionnez le modèle d'horaire à appliquer.`
    }
  },
  SCHEDULE_ASSIGN_EMPLOYEE_MODAL: {
    TITLE: `Modifier le quart de travail`,
    SUMMARY: ``,
    SENDNOTIFICATIONFORNEWEMPLOYEE: {
      LABEL: `Envoyer un avis au nouvel employé assigné`,
      DESCRIPTION: `Un avis sera envoyé au nouvel employé assigné au quart de travail.`
    },
    SENDCANCELLATIONEMAILS: {
      LABEL: `Envoyer un avis d'annulation`,
      DESCRIPTION: `Un avis d'annulation sera envoyé à l'employé qui est déassigné du quart de travail.`
    },
    SEND_CANCELLATION_NOTICE: `Un avis d'annulation sera envoyé à l'employé qui est déassigné du quart de travail.`,
    ALERT_CONFIRM_SHIFTS: `Un avis sera envoyé au nouvel employé assigné au quart de travail.`,
    SHIFT_IN_LIST_WARNING: `Un ou plusieurs quarts de travail sont dans une liste de contact, assigner un nouvel employé sur ces quarts les rendra indisponibles dans la liste.`
  },
  import: {
    TITLE: {
      TITLE: `Importer des quarts de travail`,
      SUMMARY: ``
    },
    LINE: `Ligne`,
    EMPLOYEE_NUMBER: `Numéro d'employé`,
    EMPLOYEENUMBER_DESC: `Le numéro de l'employé dans Merinio.`,
    POSITION_CODE: `Code de position`,
    POSITIONCODE_DESC: `Doit être un code de position choisi par votre administrateur.`,
    PROJECTCODE: `Code de projet`,
    PROJECTCODE_DESC: `Doit être un code de projet choisi par votre administrateur.`,
    WAGEPREMIUMS: `Code de prime`,
    WAGEPREMIUMS_DESC: `Doit être au format <1>earningCode:amount</1>, où un code de prime ayant comme code de gain <1>ABC</1> et comme quantité <1>1</1> serait importé <1>ABC:1</1>. Le code de gain doit faire partie de ceux choisis par votre administrateur. Pour entrer plusieurs codes de prime, laissez un espace entre chaque code, par exemple: <1>ABC:1</1> <1>DCE:2</1>`,
    STARTDATE: `Date`,
    STARTDATE_DESC: `La date doit être inscrite dans le format <1>YYYY-MM-DD</1>, par exemple <1>2010-01-30</1> pour le 30 Janvier 2010.`,
    START: `Début`,
    START_DESC: `L'heure  de début doit être inscrite dans le format <1>HH:mm</1>, par exemple <1>16:00</1> pour 16h. `,
    END: `Fin`,
    END_DESC: `L'heure de fin doit être dans le même format que celle du début.`,
    COMMENT: `Commentaire`,
    COMMENT_DESC: `Ajouter un commentaire au quart de travail lorsque rempli.`,
    TAGS: `Tags`,
    TAGS_DESC: `Doit être des étiquettes choisies par votre administrateur. Pour entrer plusieurs valeurs, laissez un espace entre chaque code. (Champ optionnel)`,
    DAYINTEMPLATE: `Jour dans le modèle`,
    DAYINTEMPLATE_DESC: `Si le modèle est multi-jours, chiffre qui indique le jour auquel sera ajouté le quart de travail. Si rien n'est indiqué, le quart de travail sera ajouté au premier jour du modèle. <1>1</1> pour le premier jour, <1>2</1> pour le deuxième jour, etc.`,
    ISEXTRASHIFT: `Fin variable`,
    ISEXTRASHIFT_DESC: `Indique si le quart de travail est un quart de travail avec une heure de fin variable (comme dans l'horaire). Entrer un '<0>X</0>' dans la cellule signifie <0>OUI</0>, la laisser vide signifie <0>NON</0>.`,
    ISOVERTIME: `Temps supplémentaire`,
    ISOVERTIME_DESC: `Indique si le quart de travail est en temps supplémentaire (Mêmes instructions que <0>isExtraShift</0>).`,
    ISONCALL: `Sur appel`,
    ISONCALL_DESC: `Indique si le quart de travail est un quart sur appel (Mêmes instructions que <0>isExtraShift</0>).`,
    NONBILLABLE: `Non facturable`,
    NONBILLABLE_DESC: `Indique si le quart de travail est non facturable (Mêmes instructions que <0>isExtraShift</0>).`,
    ISIRREPLACEABLE: `Ne doit pas être remplacé`,
    ISIRREPLACEABLE_DESC: `Indique si le quart de travail ne doit pas être remplacé (Mêmes instructions que <0>isExtraShift</0>).`,
    NEEDSREPLACEMENT: `Doit être comblé`,
    NEEDSREPLACEMENT_DESC: `Indique si le quart de travail doit être comblé (Mêmes instructions que <0>isExtraShift</0>).`,
    NOEMPLOYEEAVAILABLE: `Aucun employé disponible`,
    NOEMPLOYEEAVAILABLE_DESC: `Indique si le quart de travail n'a pas d'employé disponible (Mêmes instructions que <0>isExtraShift</0>).`,
    HASSPECIFICREQUIREMENTS: `A des requis spécifiques`,
    HASSPECIFICREQUIREMENTS_DESC: `Indique si le quart de travail a des requis spécifiques (Mêmes instructions que <0>isExtraShift</0>).`,
    COVEREDOTHERUNIT: `Couvert par une autre unité`,
    COVEREDOTHERUNIT_DESC: `Indique si le quart de travail sera couvert par une autre unité d'affaires (Mêmes instructions que <0>isExtraShift</0>).`,
    DELETE: `Supprimer`,
    DELETE_DESC: `Si un quart de travail a un début/fin/employé identique, il sera sélectionné pour la suppression (Mêmes instructions que <0>isExtraShift</0>).`,
    DOWNLOAD_TEMPLATE: `Télécharger un modèle de fichier`,
    MISSING_HEADERS: `Entête manquant : <0>{{value}}</0>`,
    MISSING_HEADERS_other: `Entêtes manquants : <0>{{value}}</0>`,
    TEMPLATE_FILE_NAME: `importation_quart_de_travail`,
    SHIFTS_SAVING_FAILED: `Il y a <0>{{count}}</0> quart qui n'a pas été sauvegardé.`,
    SHIFTS_SAVING_FAILED_other: `Il y a <0>{{count}}</0> quarts qui n'ont pas été sauvegardés.`,
    SHIFTS_NOT_VALID: `Il y a <0>{{count}}</0> quart invalide.`,
    SHIFTS_NOT_VALID_other: `Il y a <0>{{count}}</0> quarts invalides.`,
    INVALID_TEMPLATE: `Modèle d'horaire invalide.`,
    FULL_SHIFT: `shift entier`,
    VALIDATION: `Validation`
  },
  SHIFT_MORE_THEN_16HOURS: `Le quart de travail est de plus de 16 heures.`,
  PUNCH_ARRIVAL: `Heure d'entrée: {{time}}`,
  PUNCH_LEAVE: `Heure de sortie: {{time}}`,
  CREATE_ATTENDANCE: {
    TITLE: `Créer une requête d'absence`,
    SUMMARY: `Ceci permet de créer rapidement une requête d'absence pour un employé.`
  },
  CANT_DROP_ON_PROJECT: `Vous ne pouvez pas assigner un quart de travail à un projet.`,
  CANT_DROP_ON_TEAM: `Vous ne pouvez pas assigner un quart de travail à une équipe.`,
  CANT_DROP_ON_TIME_OFF: `Vous ne pouvez pas assigner un quart de travail à un congé`,
  CANT_DROP_ON_ABSENCE: `Vous ne pouvez pas assigner un quart de travail à une absence`,
  CANT_DROP_ON_NON_ASSIGNABLE_POSITION: `Vous ne pouvez pas assigner un quart de travail à une position non-assignable.`,
  TOO_MUCH_IDENTICAL_SHIFT: `Vous ne pouvez pas créer plus de {{number}} quarts identiques à la fois. Pour en créer plus de {{number}}, veuillez le faire en plusieurs actions.`,
  DATE_TOO_FAR: `Vous ne pouvez pas créer une récurrence pour plus de 2 ans.`,
  QUICK_ASSIGN: {
    TITLE: `Assignation rapide`,
    SUMMARY: `Cet outil permet de visualiser les employés disponibles selon certains filtres et de pouvoir les assigner à l'horaire.`,
    PRIMARY_ACTION: `Créer des quarts`,
    CREATE_TIME_OFF: `Créer des requêtes de congé`,
    EXPORT_SELECTION: `Exporter la sélection`
  },
  LEGEND: {
    TITLE: `Légende`,
    SHIFT_SECTION_TITLE: `Statuts du quart de travail`,
    SHORTCUTS_SECTION_TITLE: `Raccourcis clavier`,
    SHIFT_STATE: {
      PUBLISHED: `Quart publié`,
      NOTIFIED: `Quart notifié`,
      CONFIRMED: `Quart confirmé`,
      COMMENTED: `Commentaire(s)`,
      LOCKED: `Quart finalisé`,
      CONTACTLIST: `Liste de contacts`
    },
    PUNCH_IN: `Poinçon d'entrée`,
    PUNCH_OUT: `Poinçon de sortie`,
    OPENED_NOTIF: `Notification consultée`,
    ABSENCE_REASONS: {
      ABSENT: `Absence`,
      LATE_EARLY_OUT: `Retard/Départ hâtif`,
      TIME_OFF: `Congé`,
      REPLACEMENT: `Remplacement`
    },
    SELECTED_SHIFT: `Quart sélectionné`,
    UNASSIGNED_SHIFT: `Quart non assigné`,
    UNASSIGNED_SHIFT_SAMPLE: `Non assigné`,
    UNASSIGNED_SHIFT_TAGS: {
      ACTION_REQUIRED: `Doit être comblé`,
      NO_ACTIONS: `Aucun employé disponible / Couvert par une autre unité`
    },
    ATENTION_MENTIONNED: `Ne doit pas être remplacé / A des requis spécifiques`,
    PAY_AFFECT: {
      OVER_TIME: `Temps supplémentaire`,
      ON_CALL: `Sur appel`
    },
    SHORTCUT_ACTIONS: {
      SELECT_ALL: `Sélectionner tous les quarts`,
      SELECT_SOME: `Sélectionner des quarts par clics`,
      SELECT_MANY: `Sélectionner des quarts avec l'outil de sélection rectangle`,
      COPY: `Copier la sélection`,
      PASTE: `Coller la sélection`,
      FILTER_NAV: `Naviguer dans les filtres`,
      ADD_FILTER: `Ajouter ou retirer un filtre`,
      ESCAPE: `Fermer le menu déroulant`,
      SEARCH: `Lancer la recherche`
    },
    SHIFT_SAMPLE: {
      ABSENT: `Est absent`,
      LATE_EARLY_OUT: `Arrivé à 10:00`,
      TIME_OFF: `En congé`,
      UNASSIGNED_SHIFT: `Non assigné`,
      ACTION_REQUIRED: `Doit être comblé`,
      NO_ACTIONS: `Aucun employé disponible`,
      ATENTION_MENTIONNED: `Ne doit pas être remplacé`,
      OVER_TIME: `Temps supplémentaire`,
      ON_CALL: `Sur appel`
    }
  },
  REQUIRED_FIELD: `Ce champs est requis.`,
  PUBLISHED_STATUS: {
    PUBLISHED_COUNT: `{{publishedCount}}/{{totalCount}} publiés`,
    PUBLISH_ALL: `Publier l'horaire complet`,
    FILTER_UNPUBLISHED: `Afficher les quarts de travail non publiés`,
    SEND_SHIFT_NOTIFICATION: `Envoyer des notifications aux quarts de travail publiés`
  },
  UNAVAILABLE_STATUS: {
    UNAVAILABLE_COUNT: `{{ count }} absent/en congé`,
    UNASSIGN_ALL: `Désassigner tous les quarts en absence/congé`
  },
  EMPLOYEE_SCHEDULE: {
    TITLE: `Horaire de {{employeeName}}`,
    SUMMARY: ``
  },
  SCHEDULE_NOTE: {
    TITLE: `Notes de l'horaire`,
    SUMMARY: `Ceci permet de créer des notes pour l'horaire.`,
    NO_RESULTS: `Aucune note pour aujourd'hui.`,
    ADD_UPDATE_SCHEDULE_NOTE: `Ajouter ou Modifier une note pour l'horaire`
  },
  ATTACHMENTS: {
    DELETE_BUTTON: {
      TITLE: `Suprimer pièce jointe`,
      SUMMARY: `Êtes-vous sûr de vouloir supprimer cette pièce jointe?`,
      PRIMARY_ACTION: `Suprimer pièce jointe`
    },
    OPEN_BUTTON: `Ouvrir`
  }
}
